import { CompleteWebhook } from '../../../../generated';
import type { TypePolicies } from '../../../../utils/types/TypePolicies';
import { readEntityCacheFragmentById } from '../../account-settings/utils/typePolicyUtils';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      selectedWebhooks: {
        read: (_existing, { cache, args }) =>
          args.webhookIds.map((id: any) =>
            readEntityCacheFragmentById({
              cache,
              fragment: CompleteWebhook,
              fragmentName: 'CompleteWebhook',
              selector: {
                id,
                __typename: 'Webhook',
              },
            })
          ),
      },
    },
  },
};
